/**
 * @module app.shared
 */

import { autoinject, bindable } from 'aurelia-framework';
import { map } from 'app/shared/lib/noop';
import { fireEvent } from 'app/shared/lib/fire-events';

const LOADING_CHANGED_EVENT = 'loading-changed';
const PAGE_LOADING_CLASS = 'ess-page-loading';
const LOADING_CLASS = 'ess-loading';
const LOADERS = new Map<EssLoadingCustomAttribute, boolean>();

function sync() {
    const loading = Array.from(LOADERS.values()).some(map);
    document.body.classList.toggle(PAGE_LOADING_CLASS, loading);
}

export interface ILoading {
    loading: boolean;
}

@autoinject()
export class EssLoadingCustomAttribute implements ILoading {

    @bindable({ primaryProperty: true })
    public loading: boolean = false;

    constructor(protected readonly element: Element) { }

    protected attached(): void {
        this.fireEvents(this.loading);
    }

    protected unbind(): void {
        LOADERS.delete(this);
        sync();
        this.fireEvents(false);
    }

    protected loadingChanged(loading: boolean): void {
        this.element.classList.toggle(LOADING_CLASS, loading);
        LOADERS.set(this, loading)
        sync();

        if(this.element.isConnected) {
            this.fireEvents(loading);
        }
    }

    private fireEvents(loading: boolean): void {
        fireEvent(this.element, LOADING_CHANGED_EVENT, { detail: { loading } });
    }

}
